import { Button } from "@teamscheme/button";
import { ButtonLink } from "@teamscheme/button-link";
import NokPrice from "@teamscheme/nok-price";
import { onDesktop } from "@teamscheme/theme";
import { HTMLAttributes } from "react";
import styled, { css } from "styled-components";
import { useAuth } from "../../auth/AuthProvider";
import Illustration from "./illustrations/woman_watering_plant_620x498.svg";
import { useStaticUpgradeProducts } from "./UpgradeSection";

const IMAGE_WIDTH = 300;
const IMAGE_WIDTH_MOBILE = 200;

const Label = styled.h3`
  ${({ theme }) => theme.fontStyle.ui.label};
`;

const PayWithVippsBanner = styled(function ({
  ...props
}: HTMLAttributes<Omit<HTMLDivElement, "children">>) {
  const auth = useAuth();
  const products = useStaticUpgradeProducts();
  return (
    <>
      <div {...props}>
        <aside>
          <img
            src={Illustration}
            width={IMAGE_WIDTH}
            height={(498 / 620) * IMAGE_WIDTH}
            alt="Betal med vipps"
          />
        </aside>
        <section>
          <Label>NYHET!</Label>
          <h2>Kjøretøyet kan betales med Vipps!</h2>
          <p>
            Når dokumentene er signert kan betalingen overføres gebyrfritt med
            Vipps samtidig som kjøretøyet skifter eier hos Statens vegvesen.
            Forutsetter oppgradering til Premium{" "}
            {products.premium ? (
              <span>
                (
                <NokPrice value={products.premium.product.price} />)
              </span>
            ) : null}
            . Gratis for NAF-medlemmer!
          </p>
          <ActionButtonWrapper>
            {products.premium ? (
              <Button variant="primary" linkTo={products.premium.link}>
                Velg Premium
              </Button>
            ) : null}
            {!auth.isAuthenticated ? (
              <ButtonLink
                variant="secondary"
                onClick={() =>
                  auth.loginWithRedirect({
                    targetUrl: window.location.pathname,
                  })
                }
              >
                Logg inn som medlem
              </ButtonLink>
            ) : null}
          </ActionButtonWrapper>
        </section>
      </div>
    </>
  );
})`
  ${({ theme: { spacing, nafColor, fontStyle } }) => css`
    padding: ${spacing.space32};
    background: ${nafColor.signature.yellow10};
    width: 100%;
    flex: 1;

    h2 {
      ${fontStyle.header1};
    }

    img {
      width: ${IMAGE_WIDTH_MOBILE}px;
      height: ${(498 / 620) * IMAGE_WIDTH_MOBILE}px;
    }

    ${onDesktop`
      display: flex;
      padding: ${spacing.space64};
      aside {
        padding-left: ${spacing.space48};
        margin-left: auto;
        margin-right: 0;
        align-self: center;
        order: 1;
      }
      img {
        width: ${IMAGE_WIDTH}px;
        height: ${(498 / 620) * IMAGE_WIDTH}px;
      }
    `}
  `}
`;

const ActionButtonWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.space16};
  ${onDesktop`flex-direction: row`};
`;

export default PayWithVippsBanner;
